/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/adminConnections.scss';
import {ChangeFunction, DVRDSwitch, Loader} from '@dvrd/dvr-controls';

import React from 'react';
import Connection from '../../../models/connectionModel';
import classNames from 'classnames';
import {ConnectionStatus} from '../../../util/interfaces';
import IDate from '@dvrd/idate';
import {getMaintenanceMode} from '../../../util/maintenanceUtil';

interface Props {
    onToggleMaintenance: ChangeFunction<boolean>;
    connections: Array<Connection>;
    loading: boolean;
}

function getLastChanged(connection: Connection): string {
    const {statusChangedAtDate} = connection;
    if (!statusChangedAtDate) return 'n.v.t.';
    const now = IDate.now();
    const format = now.isAt(statusChangedAtDate, 'd') ? 'HH:mm' : 'DD-MM-YYYY HH:mm';
    return statusChangedAtDate.format(format);
}

export default function AdminConnections(props: Props) {
    const {onToggleMaintenance, connections, loading} = props;

    function renderMaintenanceToggle() {
        return (
            <DVRDSwitch onChange={onToggleMaintenance} value={getMaintenanceMode()} labels={['Onderhoud', '']}
                        className='maintenance-switch'/>
        );
    }

    function renderConnection(connection: Connection, index: number) {
        const statusMap: Record<ConnectionStatus, [string, string]> = {
            [ConnectionStatus.UP]: ['up', 'Up'],
            [ConnectionStatus.UNSTABLE]: ['unstable', 'Instabiel'],
            [ConnectionStatus.DOWN]: ['down', 'Down']
        };
        const [status, title] = statusMap[connection.status];
        return (
            <div className={classNames('connection', status)} key={index}>
                <div className='connection-indicator' title={title}/>
                <span className='connection-label'>{connection.translatedName}</span>
                <label className='checked-label'>Laatst gewijzigd: {getLastChanged(connection)}</label>
            </div>
        );
    }

    return (
        <div className='connections-container'>
            <Loader active={loading}/>
            {renderMaintenanceToggle()}
            <label className='connections-label'>Verbindingen</label>
            <div className='admin-connections'>
                {connections.map(renderConnection)}
            </div>
        </div>
    );
}